import { postNotificationActions } from '@/redux/actions/service-directory/notification';
import { NotificationInstance } from '@/services/service-directory/notification';
import { ActionType } from 'deox';
import { all, call, put, takeLatest } from 'redux-saga/effects';

export function* postNotificationSaga(action: ActionType<typeof postNotificationActions.request>) {
  const { email, message, entityId, name, phone, type } = action.payload;
  try {
    yield call(NotificationInstance.createNotification, email, entityId, message, name, phone, type);
    yield put(postNotificationActions.success());
  } catch (err) {
    yield put(postNotificationActions.failure(err));
  }
}

export default function* root() {
  yield all([takeLatest(postNotificationActions.request.type, postNotificationSaga)]);
}
